import {
  ACCESS_LEVELS,
  FEATURE_FLAGS,
} from '@/lib/consts.js'
import { __t } from '@/lib/helpers.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'
import TurnTrackerDataProvider from '@/router/routes/business/settings/data-providers/turn-tracker.js'

export default {
  path: 'advanced-options',
  name: 'settings-advanced-options',
  meta: {
    title: __t('routes.settings.advanced-options.title'),
    subtitle: __t('routes.settings.advanced-options.subtitle'),
    icon: 'advanced-options',
    backgroundIcon: 'advanced-options',
    [ROUTE_META_PARAMS.IS_TILES_VIEW]: true,
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
    [ROUTE_META_PARAMS.SEARCH_IS_VISIBLE]: true,
    [ROUTE_META_PARAMS.SEARCH_PLACEHOLDER]: __t('components.settings.advanced-options.search'),
  },
  component: () => import('@/views/business/settings/new-index.vue'),
  children: [
    {
      path: 'booking-settings',
      name: 'advanced-options-booking-settings',
      meta: {
        title: __t('routes.settings.advanced-options.booking-settings.title'),
        subtitle: __t('routes.settings.advanced-options.booking-settings.subtitle'),
        hintKey: 'hintBookingSettings',
      },
      component: () => import('@/views/business/settings/advanced-options/booking-settings/index.vue'),
    },
    {
      path: 'document-numbering',
      name: 'advanced-options.document-numbering',
      meta: {
        title: __t('routes.settings.advanced-options.document-numbering.title'),
        subtitle: __t('routes.settings.advanced-options.document-numbering.subtitle'),
        hintKey: 'hintFeatureDocumentsNumbering',
      },
      component: () => import('@/views/business/settings/advanced-options/document-numbering/index.vue'),
    },
    {
      path: 'text-messages',
      name: 'advanced-options-text-messages',
      meta: {
        title: __t('routes.settings.advanced-options.text-messages.title'),
        subtitle: __t('routes.settings.advanced-options.text-messages.subtitle'),
      },
      component: () => import('@/views/business/settings/advanced-options/text-messages/index.vue'),
    },
    {
      path: 'internal-notifications',
      name: 'advanced-options-internal-notifications',
      meta: {
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.OWNER,
        title: __t('routes.settings.advanced-options.internal-notifications.title'),
        subtitle: __t('routes.settings.advanced-options.internal-notifications.subtitle'),
      },
      component: () => import('@/views/business/settings/advanced-options/internal-notifications/index.vue'),
    },
    {
      path: 'fiscalization',
      name: 'advanced-options-fiscalization',
      meta: {
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.OWNER,
        title: __t('routes.settings.advanced-options.fiscalization.title'),
        subtitle: __t('routes.settings.advanced-options.fiscalization.subtitle'),
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: (store) => {
          const { routingConfig, app, business } = store.state
          return !!routingConfig.config.pos__bsx
            && !app.webView
            && business.pos.bsx_settings
            && business.pos.bsx_settings.visible_for_biz
        },
      },
      component: () => import('@/views/business/settings/advanced-options/fiscalization/index.vue'),
    },
    {
      path: 'turn-tracker',
      name: 'advanced-options-turn-tracker',
      meta: {
        title: __t('routes.settings.advanced-options.turn-tracker.title'),
        subtitle: __t('routes.settings.advanced-options.turn-tracker.subtitle'),
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
        [ROUTE_META_PARAMS.FEATURE_FLAG_EPPO]: FEATURE_FLAGS.Feature_TurnTracker,
        ...TurnTrackerDataProvider,
      },
      component: () => import('@/views/business/settings/advanced-options/turn-tracker/index.vue'),
    },
  ],
}
